import React from 'react';

export default function HandvaerkerfradragBox() {
  return (
    <div className="bg-slate-50 border border-slate-200 p-6 sm:p-8 rounded-xs shadow-xs my-8">
      <div className="flex items-start gap-4">
        <div className="w-10 h-10 rounded-full bg-[#0072c0]/10 text-[#0072c0] flex items-center justify-center shrink-0 mt-0.5">
          <i className="fa-solid fa-receipt text-lg" aria-hidden="true"></i>
        </div>
        <div className="flex-1 space-y-4">
          <div>
            <h3 className="text-xl font-bold uppercase tracking-tight text-stone-900 font-heading">
              Mulighed for håndværkerfradrag
            </h3>
            <p className="text-stone-700 text-sm sm:text-base leading-relaxed mt-2">
              Ved udvalgte kloak-, dræn- og klimasikringsopgaver kan private boligejere muligvis få håndværkerfradrag for arbejdslønnen.
            </p>
          </div>

          <p className="text-stone-700 text-sm sm:text-base leading-relaxed">
            Ordningen omfatter blandt andet kloakarbejde på egen grund, udskiftning af kloakrør, etablering og fornyelse af dræn, minirenseanlæg, højvandslukkere og regnvandsfaskiner.
          </p>

          <p className="text-stone-700 text-sm sm:text-base leading-relaxed">
            Belægningsarbejde kan være omfattet af servicefradraget.
          </p>

          <p className="text-stone-700 text-sm sm:text-base leading-relaxed font-medium">
            Vi udspecificerer arbejdsløn, materialer, maskiner og øvrige udgifter på fakturaen. Det er altid kundens eget ansvar at kontrollere, om betingelserne for fradrag er opfyldt.
          </p>

          <div className="bg-white border border-slate-200 p-4 rounded-xs text-xs sm:text-sm text-stone-700 space-y-2">
            <h4 className="font-heading font-bold uppercase text-stone-900 text-xs tracking-wider">
              Vigtige oplysninger:
            </h4>
            <ul className="space-y-1.5 list-disc pl-4 text-stone-700">
              <li>Fradraget gælder kun arbejdsløn – ikke materialer, maskiner, transport eller øvrige udgifter.</li>
              <li>Arbejdet skal som udgangspunkt udføres ved en eksisterende helårs- eller fritidsbolig.</li>
              <li>Nybyggeri giver ikke håndværkerfradrag.</li>
              <li>Kunden skal betale elektronisk.</li>
              <li>Kontant betaling giver ikke fradrag.</li>
            </ul>
          </div>

          <div className="pt-2">
            <a
              href="https://skat.dk/borger/fradrag/servicefradrag"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-[#0072c0] hover:bg-[#005b99] text-white text-xs sm:text-sm font-heading font-bold uppercase tracking-wider px-5 py-2.5 rounded-xs transition-colors shadow-xs"
            >
              <span>Se servicefradraget hos Skattestyrelsen</span>
              <i className="fa-solid fa-arrow-up-right-from-square text-xs" aria-hidden="true"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
